define.alias("ember-math-helpers/helpers/tan", "calendar/helpers/tan");